export default __webpack_public_path__ + "static/media/kvadar.2b951091.jpg";